module.exports = __webpack_public_path__ + "static/media/icon-smile.dfabcffe.svg";